var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-2{fill:#ff2e56;}.cls-3{fill:#23f1e7;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.5,20.16A19.5,19.5,0,1,1,20,.66a19.51,19.51,0,0,1,19.5,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.45,13.4a5.19,5.19,0,0,1-1.36-3.59h-1A5.48,5.48,0,0,0,26.45,13.4ZM13.11,29.33a7,7,0,0,0,5.05,2.17,6.89,6.89,0,0,0,6.93-6.83V16.93a6.84,6.84,0,0,0,5.14,1.75V15a2,2,0,0,1-1.09,0v2.78A6.93,6.93,0,0,1,24,16v7.73a6.86,6.86,0,0,1-6.89,6.84A7.11,7.11,0,0,1,13.11,29.33Zm5.05-11.55H18V20.7a3.4,3.4,0,0,0-.94-.14,3.15,3.15,0,0,0-1.51,5.94,3.19,3.19,0,0,1,2.6-5,2.85,2.85,0,0,1,.94.14V17.88a5.42,5.42,0,0,0-.94-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.05,9.81A6,6,0,0,1,24,8.87H20.23V23.72a3.15,3.15,0,0,1-3.16,3.16,3.22,3.22,0,0,1-1.51-.38,3.28,3.28,0,0,0,2.6,1.32,3.16,3.16,0,0,0,3.2-3.15V9.81ZM29.14,15V14a3.7,3.7,0,0,1-2.69-.61A4.44,4.44,0,0,0,29.14,15ZM17.07,16.84a6.9,6.9,0,0,0-6.93,6.88,6.81,6.81,0,0,0,3,5.61A6.87,6.87,0,0,1,18,17.78v-.85a7.47,7.47,0,0,0-.94-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.11,29.33a7.11,7.11,0,0,0,4,1.23A6.86,6.86,0,0,0,24,23.72V16a6.93,6.93,0,0,0,5.18,1.74V15a4.44,4.44,0,0,1-2.69-1.55,5.48,5.48,0,0,1-2.4-3.59H21.36V24.67a3.16,3.16,0,0,1-3.2,3.15,3.28,3.28,0,0,1-2.6-1.32,3.15,3.15,0,0,1,1.51-5.94,3.4,3.4,0,0,1,.94.14V17.78a6.87,6.87,0,0,0-4.9,11.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.7fca80618fe739e34ebf1d8977fe710c.svg";
export { ForwardRef as ReactComponent };